import Dropdown from './dropdown.vue';

Dropdown.install = function (Vue) {
  Vue.component(Dropdown.name, Dropdown);
};

export default Dropdown;
